import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useAuth } from "../providers/auth";
import api from "../services/api";
import axiosInstance from "../apis/gvmdesk";
import useAxiosFunction from "../hooks/useAxiosFunction";
import openToast from "../utils/sweetAlert";
import Popup from "./Popup";
import PopupTags from "./PopupTags";
import PopupSocialMediaUserId from "./PopupSocialMediaUserId";
import PopupChooseChat from "./PopupChooseChat";
import PopupChatTags from "./PopupChatTags";
import Input from "./Input";
import Textarea from "./Textarea";
import Button from "./Button";
import Spinner from "./Spinner";
import NewInput from "./NewInput";
import PhoneNumber from "./PhoneNumber";
import InputOptions from "./InputOptions";
import InputControlledMask from "./Forms/InputControlledMask";
import LoadingCenter from "./LoadingCenter";
import { CButton } from "@coreui/react";
import { Search } from "react-feather";
import PopupSoares from "../views/PopupSoares";
import PopupCustomerEmail from "../views/PopupCustomerEmail";
// import PopupConsulti from "./PopupConsulti"; // desativado
import PopupTransferCustomerProspect from "./PopupTransferCustomerProspect";
import { formatAdminTransferLabel } from "../utils/porte";

function ChatModals(props) {
  const {
    // Template e contrato
    tempTrigger,
    setTempTrigger,
    tempContractTrigger,
    setTempContractTrigger,

    // Dados necessários
    currentChatId,
    isChatSelected,
    selectedChats,
    forwardMessages,
    setforwardMessages,

    // Tags (filtro de chats)
    buttonPopupChatTags,
    setButtonPopupChatTags,
    setSelectedTags,
    blockLongPooling,

    // Social media seleção
    idCustomer,
    socialMedias,
    setMedia,
    handleChatBack,
    fetchMessagesById,
    buttonPopupSocialMediaFilter,
    setButtonPopupSocialMediaFilter,
    buttonPopupChoose,
    setButtonPopupChoose,
    setAvailable,

    // Chat Tags (lado direito)
    buttonPopupTags,
    setButtonPopupTags,
    info,
    editInfoAdmin,
    currentChat,

    // Redes sociais (whatsapp)
    buttonPopupSocialMedia,
    setButtonPopupSocialMedia,

    // Ligar / selecionar telefone
    buttonPopupLigar,
    setButtonPopupLigar,
    infoLoadingLigar,
    listPhones,
    infoLoading,

    // Busca/Encaminhar mensagens
    buttonPopupForward,
    setButtonPopupForward,
    search,
    handleSearchByName,
    handleSearchUsersByName,
    chats,
    users,
    list,

    // Editar observação
    buttonPopupObs,
    setButtonPopupObs,

    // Novo contato
    buttonPopupNewContact,
    setButtonPopupNewContact,

    // Feedbacks globais
    buttonPopupError,
    setButtonPopupError,
    buttonPopupSuccess,
    setButtonPopupSuccess,
    buttonPopupSendMessage,
    setButtonPopupSendMessage,
  } = props;

  // Extra modals (migrated)
  const {
    modalConditional,
    setModalConditional,
    conditionalCustomer,
    mutationConditional,
    soares,
    setSoares,
    customerEmail,
    setCustomerEmail,
    // consultiTrigger,
    // setConsultiTrigger,
    triggerTransfer,
    setTriggerTransfer,
    // Email selector popup
    email,
    setEmail,
    // Transfer conversation (admins)
    popupTransferConversation,
    setPopupTransferConversation,
    infoLoadingTransfer,
    admins,
    register,
    handleSubmit,
    submitTransfer,
    error,
    success,
  } = props;

  const { user } = useAuth();
  const [response, , loadingTemplate, messageError, axiosFetch] = useAxiosFunction();

  // Local forms
  const templateForm = useForm();
  const phoneForm = useForm();
  const forwardForm = useForm();
  const obsForm = useForm();
  const contactForm = useForm();
  // Prospect transfer props from parent
  const {
    popupProspect,
    setPopupProspect,
    registerProspect,
    handleSubmitProspect,
    prospectErrors,
    prospectLoading,
    transferProspect,
  } = props;

  // Local states
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [loadingUpdateSocialMedia, setLoadingUpdateSocialMedia] = useState(false);
  const [localError, setLocalError] = useState("");
  const [localSuccess, setLocalSuccess] = useState("");
  const [loadingNovoContato, setLoadingNovoContato] = useState(false);

  // Handlers internos
  const sendChoice = async data => {
    try {
      let ids = [];
      (selectedChats || []).forEach(chat => ids.push(chat.chat_id));
      const body = isChatSelected ? ids : [currentChatId];

      if (data.template?.includes("enviar_lote")) {
        await axiosFetch({ axiosInstance, method: "POST", url: "/chats/sendlote", redirect_to: "", data: { codigo_lote: data.code, chats_id: body } });
      }

      if (data.template?.includes("link_login")) {
        await axiosFetch({ axiosInstance, method: "POST", url: "/chats/linklogin", redirect_to: "", data: { codigo_lote: data.code, chats_id: body } });
      }
    } catch (e) {
      // silent
    }
  };

  const sendContract = async () => {
    try {
      const res = await api.post("/messages/send/contrato", { chat_id: currentChatId }, { headers: { Authorization: "Bearer " + user.token } });
      if (!res.data.error) {
        openToast("success", "Sucesso", res.data.message);
        setTempContractTrigger(false);
      } else {
        openToast("error", "Ocorreu um erro", res.data.message);
      }
    } catch (e) {
      openToast("error", "Ocorreu um erro", "Falha ao enviar contrato");
    }
  };

  const updateSocialMedia = async () => {
    setLocalError("");
    setLocalSuccess("");
    setLoadingUpdateSocialMedia(true);
    try {
      const response = await api.post("/users/update/whatsapp", { whatsapp: whatsappNumber, user_id: info.id }, { headers: { Authorization: "Bearer " + user.token } });
      if (response.data.error) {
        setLocalSuccess("");
        setLocalError(response.data.message);
        setButtonPopupError(true);
      } else {
        setLocalError("");
        setLocalSuccess(response.data.message);
        setButtonPopupSuccess(true);
      }
    } finally {
      setWhatsappNumber("");
      setLoadingUpdateSocialMedia(false);
      setButtonPopupSocialMedia(false);
    }
  };

  const setNumber = async data => {
    setLocalError("");
    try {
      const response = await api.post("/calls/ligarsl", { user_id: info.id, phone: data.number }, { headers: { Authorization: "Bearer " + user.token } });
      if (response.data.error === true) {
        setLocalError(response.data.message);
      }
    } catch (e) {
      // silent
    }
  };

  const onSelectedChats2 = async data => {
    try {
      const response = await api.post("/messages/forward", { chats_id: data.chats, messages_id: [forwardMessages] }, { headers: { Authorization: "Bearer " + user.token } });
      setforwardMessages && setforwardMessages(false);
    } catch (e) {
      // silent
    }
  };

  const editObservation = async data => {
    try {
      const response = await api.post("/users/observation", { body: data.observation, user_id: info.id }, { headers: { Authorization: "Bearer " + user.token } });
      if (!response.data.error) {
        openToast("success", "Sucesso", response.data.message);
        setButtonPopupObs(false);
        editInfoAdmin && editInfoAdmin();
      } else {
        openToast("error", "Erro", response.data.message);
      }
    } catch (e) {
      openToast("error", "Erro", "Ocorreu um erro na sua solicitação.");
      setButtonPopupObs(false);
    }
  };

  const novoContato = async data => {
    setLocalError("");
    setLocalSuccess("");
    setLoadingNovoContato(true);
    try {
      if (data.new_number?.length === 17) {
        data.new_number = data.new_number.slice(0, -1);
      }
      const response = await api.post("/users/novo/contato", { name: data.new_name, phone: data.new_number }, { headers: { Authorization: "Bearer " + user.token } });
      if (response.data.error === true) {
        setLocalSuccess("");
        setLocalError(response.data.message);
        setButtonPopupError(true);
      } else {
        setButtonPopupNewContact(false);
        contactForm.reset();
        openToast("success", "Cliente adicionado", response.data.message || "Cliente adicionado e chat iniciado.");
        // coloquei 1 pra n achar que é um Chat Assumível
        fetchMessagesById(response.data.chat_id, response.data.user_id, 1);
        handleChatBack();
      }
    } catch (e) {
      setLocalSuccess("");
      setLocalError(e.response?.data?.message || "Não foi possível adicionar o cliente.");
      setButtonPopupError(true);
    } finally {
      setLoadingNovoContato(false);
    }
  };

  return (
    <>
      {/* E-mail options */}
      <Popup title="E-mail" trigger={email} setTrigger={setEmail}>
        <div className="x-p-20 y-p-20">
          <CButton type="submit" color="primary" className="ml-10" onClick={() => setSoares(true)}>
            Telefone para o Soares
          </CButton>
          <CButton type="submit" color="primary" className="ml-10" onClick={() => setCustomerEmail(true)}>
            E-mail de contato p/ cliente
          </CButton>
        </div>
      </Popup>
      {/* Condicional */}
      <Popup title="Colocar cliente em condicional" trigger={modalConditional} setTrigger={setModalConditional}>
        <div className="x-p-20 y-p-20">
          <p className="text-color">
            Tem certeza que deseja colocar o cliente <strong>{currentChat?.current?.name}</strong> em condicional?
          </p>
          <CButton type="submit" color="primary" onClick={conditionalCustomer} disabled={mutationConditional?.isLoading}>
            {mutationConditional?.isLoading ? "Carregando..." : "Concluir"}
          </CButton>
        </div>
      </Popup>

      {/* E-mails/Consultas */}
      <PopupSoares trigger={soares} setTrigger={setSoares} chat={currentChat?.current} />
      <PopupCustomerEmail trigger={customerEmail} setTrigger={setCustomerEmail} chat={currentChat?.current} />
      {/** ViaConsulti desativado */}
      {/* {false && <PopupConsulti trigger={consultiTrigger} setTrigger={setConsultiTrigger} />} */}

      {/* Transferência solicitada */}
      <PopupTransferCustomerProspect
        chatId={currentChat?.current?.chat_id}
        customer={currentChat?.current?.user_id}
        trigger={triggerTransfer}
        setTrigger={setTriggerTransfer}
      />

      {/* Transferir conversa (admins) */}
      <Popup title="Transferir conversa" trigger={popupTransferConversation} setTrigger={setPopupTransferConversation} height="700">
        {infoLoadingTransfer ? (
          <LoadingCenter />
        ) : (
          <div className="chat__filter u-mb-1">
            {error && <div className="u-padding"><p className="text-error">{error}</p></div>}
            {success && <div className="u-padding"><p>{success}</p></div>}

            <form onSubmit={handleSubmit(submitTransfer)}>
              {user?.group_id === 8 && (
                <div className="d-flex justify-content-center align-center p-3">
                  <span className="text-center text-orange">Essa conversa será analisada, verificando uma menção ao Administrador escolhido.</span>
                </div>
              )}
              <ul className="filter__list">
                {admins && admins.map((admin, index) => (
                  <label key={index} className="list__label">
                    <li className="list__item">
                      <input className="radio__btn" type="radio" name="admin" value={admin.id} {...register("admin")} />
                      <div className="list__item__image" style={{ backgroundImage: `url(${admin.profile_picture})` }} />
                      <p className="list__item__name">{formatAdminTransferLabel(admin)}</p>
                    </li>
                  </label>
                ))}
              </ul>
              <div className="u-padding">
                <button className="btn btn-primary" type="submit">Transferir chat</button>
              </div>
            </form>
          </div>
        )}
      </Popup>
      <Popup title="Enviar template" trigger={tempTrigger} setTrigger={setTempTrigger}>
        <form onSubmit={templateForm.handleSubmit(sendChoice)}>
          <div className="padding-inner" style={{ paddingTop: "0px" }}>
            <ul className="d-flex" style={{ listStyle: "none", paddingLeft: 0 }}>
              <li className="mr-10">
                <label className="checkbox__label">
                  <input type="radio" name="template" value="enviar_lote" {...templateForm.register("template")} />
                  <span className="ml-5">Enviar lote</span>
                </label>
              </li>
              <li>
                <label className="checkbox__label">
                  <input type="radio" name="template" value="link_login" {...templateForm.register("template")} />
                  <span className="ml-5">Link de login</span>
                </label>
              </li>
            </ul>

            {templateForm.formState.errors?.template && <div>{templateForm.formState.errors.template.message}</div>}

            <Input label="Código" name="code" type="text" placeholder="12345" register={templateForm.register} />

            <div className="mt-3">
              <Button title="Enviar" type="submit" color="green" width="full" loading={loadingTemplate} />
            </div>
          </div>
        </form>
      </Popup>

      <Popup title="Enviar contrato de adesão do site" trigger={tempContractTrigger} setTrigger={setTempContractTrigger}>
        <div className="sm-body">
          <p className="text-color">Deseja enviar um contrato de adesão do site?</p>

          <div className="popup-footer">
            <button className="btn btn-primary" type="button" onClick={sendContract}>
              {false ? <Spinner /> : "Enviar contrato"}
            </button>
            <button className="btn btn-light mr-20" type="submit" onClick={() => setTempContractTrigger(false)}>Cancelar</button>
          </div>
        </div>
      </Popup>

      <PopupTags trigger={buttonPopupChatTags} setTrigger={setButtonPopupChatTags} setSelectedTags={setSelectedTags} blockLongPooling={blockLongPooling} />

      <PopupSocialMediaUserId
        idCustomer={idCustomer}
        socialMedias={socialMedias}
        setSelectedMedia={setMedia}
        handleChatBack={handleChatBack}
        blockLongPooling={blockLongPooling}
        fetchMessagesById={fetchMessagesById}
        trigger={buttonPopupSocialMediaFilter}
        setTrigger={setButtonPopupSocialMediaFilter}
      />

      <PopupChooseChat
        idCustomer={idCustomer}
        socialMedias={socialMedias}
        setSelectedMedia={setMedia}
        handleChatBack={handleChatBack}
        blockLongPooling={blockLongPooling}
        fetchMessagesById={fetchMessagesById}
        trigger={buttonPopupChoose}
        setTrigger={setButtonPopupChoose}
        setAvailable={setAvailable}
      />

      <PopupChatTags title="Gerenciar tags" info={info} trigger={buttonPopupTags} setTrigger={setButtonPopupTags} editInfoAdmin={editInfoAdmin} chat={currentChat} />

      <Popup title="Redes sociais" trigger={buttonPopupSocialMedia} setTrigger={setButtonPopupSocialMedia} >
        <form onSubmit={e => { e.preventDefault(); updateSocialMedia(); }}>
          {localSuccess && <div style={{ paddingLeft: "20px", paddingRight: "20px" }} className="mb-10 mt-10">{localSuccess}</div>}
          {localError && <div style={{ paddingLeft: "20px", paddingRight: "20px" }} className="mb-10 mt-10">{localError}</div>}

          <div className="padding-inner" style={{ paddingTop: "0px", paddingBottom: "0px" }}>
            <NewInput mask="+99 99 9999 9999" label="WhatsApp" name="whatsapp" type="text" onChange={e => setWhatsappNumber(e.target.value)} />
          </div>

          <div className="padding-lbr">
            <Button title="Salvar" type="submit" color="green" width="full" loading={loadingUpdateSocialMedia} />
          </div>
        </form>
      </Popup>

      <Popup title="Selecionar telefone" trigger={buttonPopupLigar} setTrigger={setButtonPopupLigar} >
        {infoLoadingLigar
          ? <LoadingCenter />
          : (
            <form onSubmit={phoneForm.handleSubmit(setNumber)}>
              <div className="padding-inner" style={{ paddingTop: "0px" }}>
                {infoLoading ? (
                  <LoadingCenter />
                ) : (
                  <div className="sm-body">
                    <div className="row-grid">
                      {listPhones.map((phone, index) => (
                        <PhoneNumber key={index} title={phone.name} name="number" value={phone.name} qtd={phone.qtd} lastOne={String(phone.lastOne)} register={phoneForm.register} />
                      ))}
                    </div>
                  </div>
                )}

                {localError ? (
                  <div className="mt-20 d-flex flex-row justify-content-center align-center" style={{ color: "red" }}>
                    {localError}
                  </div>
                ) : ("")}
              </div>

              <div className="padding-lbr">
                <Button title="Ligar" type="submit" color="green" width="full" loading={false} />
              </div>
            </form>
          )}
      </Popup>

      <Popup title="Encaminhar mensagens" trigger={buttonPopupForward} setTrigger={setButtonPopupForward}>
        <div className="search">
          <div className="inner-search">
            <div className="search-icon">
              <Search size={24} />
            </div>
            <input className={`search-input ${chats.length <= 0 && "display-none"}`} type="text" placeholder="Pesquisar" onChange={(e) => handleSearchByName(e.target.value)} value={search} />
            <input className={`search-input ${users.length <= 0 && "display-none"}`} type="text" placeholder="Pesquisar" onChange={(e) => handleSearchUsersByName(e.target.value)} value={search} />
          </div>
        </div>
        <form onSubmit={forwardForm.handleSubmit(onSelectedChats2)}>
          {chats.length > 0 ? (
            list.map((chat, index) => (
              <div key={index} className="padding-inner" style={{ paddingTop: "0px" }}>
                <div className="item-left">
                  <div className={`item position-relative`} key={chat.chat_id} >
                    <div className="item-left">
                      <div className="photo-wrapper">
                        <input className="checkbox custom-checkbox" type="checkbox" name="chats" value={chat.chat_id} {...forwardForm.register("chats")} />
                        <div className="photo" style={{ backgroundImage: `url(${chat.profile_pic})` }}></div>
                      </div>
                    </div>
                    <div className="item-right">
                      <span className={`name`} style={{ marginTop: "18px", marginLeft: "15px" }}>{chat.name}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))) : (chats.length)}
          <CButton className="w-100" type="submit">Enviar para selecionados</CButton>
        </form>
      </Popup>

      {/* Transferir conversa prospect */}
      <Popup title="Transferir conversa prospect" trigger={popupProspect} setTrigger={setPopupProspect}>
        <div className="u-all-padding">
          <form onSubmit={handleSubmitProspect(transferProspect)}>
            <ul className="last-access-list mb-0">
              {infoLoadingTransfer && <LoadingCenter />}

              {!infoLoadingTransfer && admins?.length > 0 && (
                <>
                  <li className="mb-10">
                    <strong>Transferir para admin</strong>
                  </li>
                  {admins.map(admin => (
                    <li key={admin.id}>
                      <label className="label-last-accesses">
                        <input type="radio" name="prospect" value={`admin:${admin.id}`} {...registerProspect("prospect")} />
                        <span>{formatAdminTransferLabel(admin)}</span>
                      </label>
                    </li>
                  ))}
                  <li className="mt-20 mb-10">
                    <strong>Transferir automático por porte</strong>
                  </li>
                </>
              )}

              <li>
                <label className="label-last-accesses">
                  <input type="radio" name="prospect" value="PP" {...registerProspect("prospect")} />
                  <span>Pequeno porte - automático</span>
                </label>
              </li>
              <li>
                <label className="label-last-accesses">
                  <input type="radio" name="prospect" value="MP" {...registerProspect("prospect")} />
                  <span>Médio porte - automático</span>
                </label>
              </li>
              <li>
                <label className="label-last-accesses">
                  <input type="radio" name="prospect" value="GP" {...registerProspect("prospect")} />
                  <span>Grande porte - automático</span>
                </label>
              </li>
            </ul>

            {prospectErrors?.prospect && <div className="text-error">{prospectErrors.prospect.message}</div>}

            <div className="popup-footer">
              <button className="btn btn-primary" type="submit">
                {prospectLoading ? <Spinner /> : "Concluir"}
              </button>
              <button className="btn btn-light mr-20" type="button" onClick={() => setPopupProspect(false)}>Cancelar</button>
            </div>
          </form>
        </div>
      </Popup>

      <Popup title="Editar observação" trigger={buttonPopupObs} setTrigger={setButtonPopupObs} >
        <form onSubmit={obsForm.handleSubmit(editObservation)}>
          <div className="padding-inner" style={{ paddingTop: "0px" }}>
            <Textarea label="Observação" type="text" placeholder="" name="observation" register={obsForm.register} />
          </div>
          <div className="padding-lbr">
            <Button title="Salvar" type="submit" color="green" width="full" />
          </div>
        </form>
      </Popup>

      <Popup title="Adicionar novo cliente" trigger={buttonPopupNewContact} setTrigger={setButtonPopupNewContact} >
        <form onSubmit={contactForm.handleSubmit(novoContato)}>
          <div className="padding-inner" style={{ paddingTop: "0px" }}>
            <Input label="Nome do cliente" name="new_name" type="text" placeholder="João da Silva" register={contactForm.register} />
            <InputControlledMask control={contactForm.control} mask="+99 99 9999-9999" label="WhatsApp" type="text" placeholder="+55 99 9999-9999" name="new_number" />
          </div>
          <div className="padding-lbr">
            <Button title="Adicionar cliente e iniciar chat" type="submit" color="green" width="full" loading={loadingNovoContato} />
          </div>
        </form>
      </Popup>

      <Popup title="Erro" trigger={buttonPopupError} setTrigger={setButtonPopupError} >
        <p style={{ marginTop: "15px", marginLeft: "20px" }}>{localError}</p>
      </Popup>

      <Popup title="Sucesso" trigger={buttonPopupSuccess} setTrigger={setButtonPopupSuccess} >
        <p style={{ marginTop: "15px", marginLeft: "20px" }}>{localSuccess}</p>
      </Popup>

      <Popup title="Enviar mensagem para vários contatos" trigger={buttonPopupSendMessage} setTrigger={setButtonPopupSendMessage} >
        <InputOptions selectedChats={selectedChats} />
      </Popup>
    </>
  );
}

export default ChatModals;
